import { Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { CSSProperties } from "@material-ui/styles";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { RiderDispatchBatch_riderDispatchBatch } from "@saleor/dispatch/types/RiderDispatchBatch";
import { UseNavigatorResult } from "@saleor/hooks/useNavigator";
import { renderCollection } from "@saleor/misc";
import { currencyFormat } from "@saleor/utils/formatters/currencyFormat";
import * as React from "react";
import { FormattedMessage } from "react-intl";

interface TripInformationListProps {
  tripInformation: RiderDispatchBatch_riderDispatchBatch;
  loading: boolean;
  navigate: UseNavigatorResult;
  navigateUrl: (id: string) => string;
}

const useStyles = makeStyles(
  theme => {
    const dataDisplay: CSSProperties = {
      flex: "60%",
      overflow: "auto",
      textAlign: "left"
    };

    return {
      dataTitle: {
        display: "none !important"
      },
      dispatchTbl: {
        [theme.breakpoints.down("md")]: {
          "& thead": {
            display: "none !important"
          },
          "& thead, tbody, th, td, tr": {
            border: "none",
            display: "block"
          },
          "& tr": {
            backgroundColor: "#fff !important",
            borderBottom: "1px solid #ccc",
            paddingBottom: "30px",
            paddingTop: "30px"
          }
        },
        tableLayout: "auto",
        width: "100%"
      },
      [theme.breakpoints.down("md")]: {
        dataDisplay,
        dataGroup: {
          display: "flex"
        },
        dataTitle: {
          display: "block !important",
          flex: "40%",
          fontWeight: "bold",
          textAlign: "left"
        }
      },
      responsiveTable: {
        overflow: "auto !important"
      },
      tblCol: {
        fontSize: "1.3em",
        fontWeight: 600 as 600,
        whiteSpace: "nowrap",
        width: "auto"
      }
    };
  },
  {
    name: "TripInformationList"
  }
);

const TripInformationList: React.FC<TripInformationListProps> = props => {
  const { tripInformation, loading, navigate, navigateUrl } = props;
  const classes = useStyles(props);

  return (
    <div className={classes.responsiveTable}>
      <Table className={classes.dispatchTbl}>
        <TableHead>
          <TableRow>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Order Number" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Customer Name" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Address" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Payment Method" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Amount to Collect" />
            </TableCellHeader>
            {/* <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Remarks" />
            </TableCellHeader> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {renderCollection(
            tripInformation?.orders || [],
            ticket => (
              <TableRow key={ticket?.id}>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Order Number</div>
                    <div className={classes.dataDisplay}>
                      {loading ? (
                        <Skeleton />
                      ) : (
                        <Link
                          onClick={() => navigate(navigateUrl(ticket?.id))}
                          style={{
                            cursor: "pointer"
                          }}
                        >
                          {ticket?.orderCode}
                        </Link>
                      )}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Customer Name</div>
                    <div className={classes.dataDisplay}>
                      {loading ? (
                        <Skeleton />
                      ) : (
                        ticket?.user?.firstName + " " + ticket?.user?.lastName
                      )}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Address</div>
                    <div className={classes.dataDisplay}>
                      {loading ? (
                        <Skeleton />
                      ) : (
                        ticket?.shippingAddress?.streetAddress1
                      )}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Payment Method</div>
                    <div className={classes.dataDisplay}>
                      {loading ? (
                        <Skeleton />
                      ) : (
                        ticket?.payments[0]?.paymentMethodType.toUpperCase()
                      )}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Amount to Collect</div>
                    <div className={classes.dataDisplay}>
                      {loading ? (
                        <Skeleton />
                      ) : (
                        currencyFormat(ticket?.total?.gross?.amount)
                      )}
                    </div>
                  </div>
                </TableCell>
                {/* <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Remarks</div>
                    <div className={classes.dataDisplay}>
                      {moment().format("LL")}
                    </div>
                  </div>
                </TableCell> */}
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={5} padding="default">
                  <Typography variant="h5" align="center">
                    No Data
                  </Typography>
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default TripInformationList;
